import React, { useEffect, useRef, useState } from "react";
import InputField from "../../../components/inputField/InputField";
import { addIcon, searchIcon } from "../../../assets";
import { card_items, routeNames } from "../../../constants/constants";
import Card from "../../../components/card/Card";
import DashHeader from "../../../components/dashHeader/DashHeader";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { createUser, getUsers } from "../../../redux/slices/userSlice";
import { useNavigate } from "react-router-dom";
import Modal from "../../../components/modal/Modal";
import Form from "../../../components/form/Form";
import { USER_FORM } from "../../../constants/user.form.constant";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { superAdminSchema } from "../../../constants/yup.schema";
import { SetTable } from "@/components/SetTable";
import { SUPER_ADMIN_FORM } from "constants/superAdmin.form.constant";
import { createSuperAdmin, deleteSuperAdmin, getSuperAdmin, updateSuperAdmin } from "../../../redux/slices/superAdminSlice";
import get from "lodash.get";

const SuperAdmin: React.FC = () => {
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [editingSuperAdminId, setEditingSuperAdminId] = useState<string>("");
    const [searchValue, setSearchValue] = useState<string>("");
    const navigate = useNavigate();

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value);
    };

    const dispatch = useDispatch<AppDispatch>();

    const { superadmin } = useSelector((state: RootState) => state.superadmin);
    console.log("🚀 ~ superadmin:", superadmin)
    const tableKeys = [
        {
            name: "name",
        },
        {
            username: "username",
        },
        {
            email: "contactInfo.email",
        },
        {
            passweord: "plainTextPassword",
        },

    ];
    useEffect(() => {
        dispatch(getSuperAdmin());
    }, [dispatch]);

    const handleViewDetails = (user: any) => {
        // console.log(user)
        // return
        const developerId = user._id;
        navigate(`${routeNames.details + "/" + developerId}`);
    };

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const handleModal = () => setIsModalOpen(!isModalOpen);

    const defaultValues = useRef({
        name: "",
        username: "",
        password: "",
        contactInfo: {
            phone: "",
            email: "",
        },
    });
    const methods = useForm({
        defaultValues: defaultValues.current,
        resolver: yupResolver(superAdminSchema),
    });
    const {
        control,
        handleSubmit,
        reset: handleReset,
        formState: { isSubmitting, errors },
    } = methods;

    const onSubmit = async (data: any) => {
        console.log("submitting", data);
        let { name, contactInfo, username, password } = data;

        const payload = {
            name,
            contactInfo,
            username,
            password,
            role: "SuperAdmin",
        };

        try {
            if (isEdit && editingSuperAdminId) {
                await dispatch(updateSuperAdmin({ id: editingSuperAdminId, newData: payload })).unwrap();
                toast.success("super admin updated successfully!");
                setIsEdit(false);
            } else {
                await dispatch(createSuperAdmin(payload)).unwrap();
                toast.success("super admin created successfully!");
            }
            await dispatch(createSuperAdmin(payload));

            dispatch(getSuperAdmin());
            handleModal();
        } catch (error: any) {
            toast.error(`Failed to create super admin: ${error.message || error}`);
        } finally {
            handleReset();
        }
    };
    const handleEdit = async (item: any) => {
        console.log(item);
        setIsEdit(true);
        setEditingSuperAdminId(item.id);
        handleModal();
        handleReset({
            name: item.name,
            username: item.username,
            contactInfo: {
                email: item.contactInfo?.email,
                phone: item.contactInfo?.phone,
            },
            password: item?.plainTextPassword || "",
        });
    };
    const handleDelete = async (row: any) => {
        try {
            await dispatch(deleteSuperAdmin(row.id));
            toast.success("admin deleted successfully!");
            dispatch(getSuperAdmin());
        } catch (error: any) {
            toast.error(`Failed to delete admin: ${error.message || error}`);
        }
    };
    const actions = [
        {
            label: "Edit",
            style: "bg-blue-500 text-white hover:bg-blue-700",
            handler: (row: any) => handleEdit(row),
        },
        {
            label: "Delete",
            style: "bg-red-500 text-white hover:bg-red-700",
            handler: (row: any) => handleDelete(row),
        }
    ];
    return (
        <>
            <div className="flex justify-between flex-wrap mt-10">
                <div className="flex flex-col justify-between max-md:py-2 md:py-1">
                    <DashHeader title="Super Admin" icon={addIcon} onClick={handleModal} />
                </div>
            </div>
            <SetTable data={superadmin} tableKeys={tableKeys} actions={actions} />

            <Modal isModalOpen={isModalOpen} onClick={handleModal} title="Add new Super Admin">
                <Form fields={SUPER_ADMIN_FORM} control={control} method={methods} onClick={handleSubmit((data) => onSubmit(data))} errors={errors} isSubmitting={isSubmitting} style="grid grid-cols-2 gap-4" />
            </Modal>
        </>
    );
};

export default SuperAdmin;
